import { type FlowProducedType } from 'flow-schema';

import { type Common } from '../common.js';
import {
  type DeleteTestPatientDataResponse,
  type TestPatientDataSummary,
} from '../models/flow/testPatientData.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/test-patients/';

  constructor(common: Common) {
    this.common = common;
  }

  /**
   * Lookup a flow builder test patient by ehrInformationId, returning all data keyed by dataType
   */
  async findOneById(ehrInformationId: string): Promise<TestPatientDataSummary> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${ehrInformationId}`);
    return await this.common.getJSON(url);
  }

  /**
   * Create or update flow builder test patient data by ehrInformationId and dataType
   */
  async createOrUpdate(args: {
    ehrInformationId: string;
    dataType: FlowProducedType;
    mock: any;
  }): Promise<TestPatientDataSummary> {
    const { ehrInformationId, dataType, mock } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/${ehrInformationId}/${dataType}`);
    return await this.common.postJSON(url, mock);
  }

  /**
   * Delete flow builder test patient data by ehrInformationId and dataType
   */
  async delete(args: {
    ehrInformationId: string;
    dataType: FlowProducedType;
  }): Promise<DeleteTestPatientDataResponse> {
    const { ehrInformationId, dataType } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/${ehrInformationId}/${dataType}`);
    return await this.common.deleteJSON(url);
  }
}
